import ModusServiceCollection from "../ModusServiceCollection";
import ResultRecommendationModel from "../../models/modus/ResultRecommendationModel";

/**
 * ResultRecommendation collection
 */
export default class ResultRecommendationCollection extends ModusServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ResultRecommendationModel;
  }

}
